import React, { useEffect, useState } from 'react'

function CondicionOpcion(props) {
    const {preguntas,info,cambiarCondicion}=props;
    const [condicional,setCondicional] = useState('');
    const setCondicionPregunta=(valor)=>{
        setCondicional(valor);
        if(valor==0){
            cambiarCondicion(valor,info,0);
        }
    }
    const setCondicionPreguntaSalto=(valor)=>{
        cambiarCondicion(condicional,info,valor);
    }
    useEffect(()=>{
        console.log(info);
        setCondicional(info.CONDICION.split('|')[0]);
    },[info])
    return (
        <>
            <div className='text-center'>
                Condicion si Eligen esta Respuesta!!
            </div>
            <div className='btn-group px-2 ' >
                <select className="form-select form-select-sm" value={info.CONDICION?info.CONDICION.split('|')[0]:-1} onChange={(e) => setCondicionPregunta(e.target.value)}>
                    <option value={-1}>Ninguno</option>
                    <option value={0}>Finalizar Encuesta</option>
                    <option value={1}>Saltar a Pregunta</option>
                </select>
                {condicional === `1` && <>
                    <div className='my-auto mx-2'><i className="fa-solid fa-arrow-right"></i></div>
                    <select className="form-select form-select-sm" value={info.CONDICION?info.CONDICION.split('|')[1]:0} onChange={(e)=>setCondicionPreguntaSalto(e.target.value)}>
                        {preguntas.map((item, index) => {
                            return (
                                <option value={item.ID_PREGUNTA} key={index}>{`Pregunta ${index + 1}`}</option>
                            )
                        })}
                    </select></>}
            </div>
        </>
    )
}

export default CondicionOpcion
